/* eslint-disable ember/no-computed-properties-in-native-classes, warp-drive/no-legacy-request-patterns */
import { tracked } from '@glimmer/tracking';
import Controller from '@ember/controller';
import { action, computed } from '@ember/object';
import { sort } from '@ember/object/computed';
import { isEmpty } from '@ember/utils';
import moment from 'moment';
import { service } from '@ember/service';
import { findBy } from '@linc-technologies/linced-common/utils/arrays';

export default class FundingYearLevelController extends Controller {
  @action
  setDate(value) {
    this.date = value;
  }

  queryParams = ['date'];

  // Services
  @service
  session;

  @service
  store;

  @tracked date = moment().format('YYYY-MM-DD');
  today = moment().format('YYYY-MM-DD');
  sort = Object.freeze(['exitDate:desc', 'entryDate:desc']);

  @sort('model.enrolments', 'sort')
  sortedEnrolments;

  get reportTitle() {
    return `Funding Year Level as at ${this.date}`;
  }

  @computed('sortedEnrolments.[]', 'date')
  get learners() {
    let excludeTypes = ['FF', 'NF', 'EM'];
    return this.sortedEnrolments.reduce((learners, enrolment) => {
      if (isEmpty(enrolment.personId)) {
        // Return early if no personId specified
        return learners;
      }
      let person = this.store.peekRecord('person', enrolment.personId);
      if (!isEmpty(person) && isEmpty(findBy(learners, 'id', person.id))) {
        // Check that the student type is funded (and they should thus be included).
        let type = person.get('fields.nzMOE:type.value') ?? '';
        if (!excludeTypes.includes(type)) {
          learners.push({
            id: person.id,
            nsn: person.get('fields.nzMOE:nsn.value'),
            firstName: person.firstName,
            lastName: person.lastName,
            homeroomName: isEmpty(person.homeroom) ? '' : person.homeroom.name,
            fundingYearLevel: person.calculateFundingYearLevel(this.date),
            currentYearLevel: person.currentYearLevel,
          });
        }
      }

      return learners;
    }, []);
  }
}
